
import moment from 'moment'
import { mapState } from 'vuex'
import locationsWithNoCatering from '@/assets/data/locations-with-no-catering.json'
import locationsWithEzcatering from '@/assets/data/locations-with-ezcatering.json'
import locationsWithCatering from '@/assets/data/locations-with-catering.json'

export default {
  data() {
    return {
      showErrorModal: false,
      locationsWithNoCatering,
      locationsWithEzcatering,
      locationsWithCatering
    }
  },
  props: {
    location: {
      type: Object,
      default: () => { }
    },
  },
  computed: {
    ...mapState(['favelocations', 'user', 'order', 'channel']),
    isCatering() {
      return this.channel === 'catering'
    },
    hasBoCatering() {
      if (!this.isCatering) {
        return false
      }

      return this.locationsWithCatering.includes(parseInt(this.location.id))
    },
    shouldShowPickupButton() {
      if (!this.location.available) {
        return false
      }

      if (this.isCatering) {
        if (this.hasBoCatering) {
          return true
        }

        if (this.isCateringUnavailable) {
          return false
        }

        if (this.hasEzCatering) {
          return false
        }
      }

      return true
    },
    hasEzCatering() {
      if (!this.isCatering) {
        return false
      }

      if (this.hasBoCatering) {
        return false
      }

      return this.locationsWithEzcatering.some(location => location.id === parseInt(this.location.id))
    },
    ezCateringUrl() {
      if (!this.hasEzCatering) {
        return ''
      }

      return this.locationsWithEzcatering.find(location => location.id === parseInt(this.location.id)).ezcaterLink
    },
    isCateringUnavailable() {
      return this.locationsWithNoCatering.includes(parseInt(this.location.id))
    }
  },
  methods: {
    async startOrder() {
      const location = await this.$api.getLocation(this.location.menu_id, true)
      this.$store.commit('setLocation', location)
      const menu = await this.$api.getMenu()
      if (this.order && this.order.menu_id != this.location.menu_id) {
        await this.$api.transferOrder()
      } else {
        await this.$api.createOrder()
      }
      if (menu) {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          'event': 'select_location',
          'location_name': location.address,
          'location_address': location.name,
        })

        if (this.channel === 'catering') {
          this.$store.commit('setCateringConfigOrder', true)
        } else {
          this.$router.push('/order/')
        }

      }
    },
    async setActiveLocation() {
      let location = this.location
      if (this.location.menu_id) {
        location = await this.$api.getLocation(this.location.menu_id, true)
      }
      this.$store.commit('setActiveLocation', location)
    },
    openText(location) {
      if (!location.hours) {
        return
      }
      const dayOfWeek = parseInt(moment().format('e'))
      const currentDay = moment().format('ddd').toLowerCase()
      const tomorrow = moment().add(1, 'days').format('ddd').toLowerCase()
      let hours = []
      let tomorrowHours = []
      location.hours.forEach(dayHours => {
        if (dayHours.day == currentDay) {
          hours = dayHours
        }
        if (dayHours.day == tomorrow) {
          tomorrowHours = dayHours
        }
      })
      if (hours !== undefined) {
        if (hours.closed) {
          return 'Closed tomorrow'
        }
        const open = moment(hours.open, 'HH:mm')
        const close = moment(hours.close, 'HH:mm')
        const now = moment()
        const tomorrowOpen = tomorrowHours.open
        const tomorrowClose = tomorrowHours.close
        if (moment(close).format('h:mm A') == '12:00 AM' && moment(open).format('h:mm A') == '12:00 AM' && hours.holiday == null) {
          return 'Open 24 hours'
        } else if (moment(close).format('h:mm A') == '12:00 AM' && hours.holiday == null) {
          return 'Closes at midnight'
        } else if (location.currently_open & hours.holiday == null) {
          return 'Closes at ' + moment(close).format('h:mm A')
        } else if (moment(open).diff(moment(now)) > 0 && hours.holiday == null) { // not open yet today
          return 'Opens at ' + moment(open).format('h:mm A')
        } else if (tomorrowHours.holiday == null) { // opens tomorrow and not holiday tomorrow
          return 'Opens at ' + moment(tomorrowOpen, 'HH:mm').format('h:mm A')
        } else { // closed and holiday tomorrow
          return 'Closed for holiday'
        }
      }
    },
    isFave(id) {
      if (this.favelocations) {
        for (let i = 0; i < this.favelocations.length; i++) {
          if (this.favelocations[i] && this.favelocations[i].menu_id == id) {
            return true
          }
        }
      }
    },
    async toggleFavorite(location) {
      if (this.isFave(location.menu_id)) {
        await this.$api.deleteFaveLocation(location.menu_id)
        this.$braze.getUser().setCustomUserAttribute("Favorite_Locations", {
          "$remove": [{
            "$identifier_key": "Menu_ID",
            "$identifier_value": location.menu_id.toString()
          }]
        })
      } else {
        if (this.favelocations.length >= 5) {
          this.showErrorModal = true
          return
        }
        this.$braze.getUser().setCustomUserAttribute("Favorite_Locations", {
          "$add": [{
            "Store_ID": location.id.toString(),
            "Menu_ID": location.menu_id.toString(),
            "Name": location.name.toString(),
            "City": location.city.toString(),
            "State": location.state.toString(),
            "Zip": location.zip.toString(),
            "Availability": [
              ...(location.services.pickup ? ['pickup'] : []),
              ...(location.services.curbside ? ['curbside'] : []),
              ...(location.services.delivery ? ['delivery'] : []),
              ...(location.services.drivethru ? ['drivethru'] : []),
              ...(location.services.dinein ? ['dinein'] : []),
              ...(location.services.manualfire ? ['manualfire'] : []),
            ].join(', ')
          }]
        })
        await this.$api.setFaveLocation(location.menu_id)
      }
    }
  }
}
